import * as React from "react";
export const SvgPaperClip = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
		<path
			fill="#FFE5B3"
			d="M25.004 27.642H18.139v-6.937h2.268a.71.71 0 0 0 .575-1.125l-4.413-6.107a.703.703 0 0 0-1.144 0L11.01 19.58a.708.708 0 0 0 .575 1.125h2.27v6.937h-7.69C2.733 27.452 0 24.242 0 20.764c0-2.4 1.301-4.492 3.23-5.623a4.367 4.367 0 0 1-.268-1.524 4.429 4.429 0 0 1 5.95-4.165 8.877 8.877 0 0 1 8.036-5.094c4.603.007 8.396 3.531 8.827 8.023C29.313 12.99 32 16.265 32 19.973c0 3.962-3.086 7.395-6.996 7.67Z"
		/>
	</svg>
);
